import { Injectable } from '@angular/core';
import { EntityStore } from '@examdojo/state';
import { ReferenceQuestionState, ReferenceQuestionStoreModel } from './reference-question.model';

@Injectable({ providedIn: 'root' })
export class ReferenceQuestionStore extends EntityStore<ReferenceQuestionState, ReferenceQuestionStoreModel, 'id'> {
  constructor() {
    super({
      name: 'reference-questions',
      idKey: 'id',
    });
  }
}
